import $ from 'jquery';
import 'select2';                       // globally assign select2 fn to $ element
import 'select2/dist/css/select2.css';  // optional if you have css loader

// $(() => {
//     $('.select2').select2({
//         width: 'resolve'
//     });
//     $('.select2').on('select2:select', function (e) {
//         var data = e.params.data;
//         $('')
//         Livewire.emit('select2Change', data);
//     });
// });

window.addSelect2 = function(entity, id, value){
    $('#'+entity+'-'+ id).select2({
        // width: 'resolve',
        // allowClear: true
    });
    $('#'+entity+'-'+ id).val(value).trigger('change');
    $('#'+entity+'-'+ id).on('select2:select', function (e) {
        var data = e.params.data;
        Livewire.emit('select2Change', {data, id, entity});
    });
}

window.addMultipleSelect2 = function(entity, id, values){
    $('#'+entity+'-'+ id).select2({
        width: 'resolve',
        multiple: true,
    });
    $('#'+entity+'-'+ id).val(values).trigger('change');
    $('#'+entity+'-'+ id).on('select2:select', function (e) {
        var data = e.params.data;
        Livewire.emit('MultipleSelect2Select', {data, id, entity});
    });
    $('#'+entity+'-'+ id).on('select2:unselect', function (e) {
        var data = e.params.data;
        Livewire.emit('MultipleSelect2Unselect', {data, id, entity});
    });
}
